import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

const SignupModal = ({ onClose }) => {
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const { register } = useAuth()

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => document.body.classList.remove('modal-open')
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    
    const trimmedName = name.trim()
    if (!trimmedName) {
      setError('Please enter your name.')
      return
    }
    
    if (!password) {
      setError('Please set a password.')
      return
    }
    
    if (password.length < 4) {
      setError('Password must be at least 4 characters long.')
      return
    }
    
    if (password !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }

    setLoading(true)
    const result = await register({ name: trimmedName, password })
    
    if (result.success) {
      setSuccess(true)
      setTimeout(() => {
        onClose()
      }, 2000)
    } else {
      setError(result.error)
    }
    setLoading(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal signup-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create Your Account</h2>
          <button 
            className="btn ghost sm" 
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
        
        <div className="modal-content">
          {success ? (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h3>Account Created Successfully!</h3>
              <p className="muted">You can now use the LOGIN button to access your personal dashboard.</p>
            </div>
          ) : (
            <>
              <div className="signup-intro">
                <p className="muted">
                  Join BFIT and start tracking your fitness journey today.
                </p>
              </div>
              
              {error && (
                <div className="error-message">
                  <span>⚠</span>
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="signup-form">
                <div className="form-group">
                  <label htmlFor="signup-name">Full Name</label>
                  <input 
                    id="signup-name"
                    autoFocus 
                    placeholder="Enter your full name" 
                    value={name} 
                    onChange={e => setName(e.target.value)}
                    disabled={loading}
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="signup-password">Password</label>
                  <input 
                    id="signup-password"
                    type="password" 
                    placeholder="Create a secure password (min 4 characters)" 
                    value={password} 
                    onChange={e => setPassword(e.target.value)}
                    disabled={loading}
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="signup-confirm">Confirm Password</label>
                  <input 
                    id="signup-confirm"
                    type="password" 
                    placeholder="Confirm your password" 
                    value={confirmPassword} 
                    onChange={e => setConfirmPassword(e.target.value)}
                    disabled={loading}
                    className={`form-input ${password && confirmPassword && password !== confirmPassword ? 'error' : ''}`}
                  />
                  {password && confirmPassword && password !== confirmPassword && (
                    <div className="field-error">Passwords do not match</div>
                  )}
                </div>
                
                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="btn primary full-width"
                    disabled={loading || !name.trim() || !password || !confirmPassword || password !== confirmPassword}
                  >
                    {loading ? (
                      <>
                        <span className="spinner"></span>
                        Creating Account...
                      </>
                    ) : (
                      'Create Account'
                    )}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SignupModal
